import { render, staticRenderFns } from "./CleanerProfile.vue?vue&type=template&id=b4684d9a&scoped=true"
import script from "./CleanerProfile.vue?vue&type=script&lang=js"
export * from "./CleanerProfile.vue?vue&type=script&lang=js"
import style0 from "./CleanerProfile.vue?vue&type=style&index=0&id=b4684d9a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4684d9a",
  null
  
)

export default component.exports